import React from "react";
import { HubCardStack } from "../../components";
import ShipmentOrdersBar from "./ShipmentOrdersBar";
import { ShipmentOrdersTable } from "../../tables";
import { useShipmentOrdersContext } from "./ShipmentOrdersContextProvider";
import { ShipmentDetailsDialog } from "../../dialogs";

const ShipmentOrdersContent = ({ defaultLocation }) => {
  const { returnType } = useShipmentOrdersContext();

  return (
    <HubCardStack height="100%" gap="15px">
      <ShipmentOrdersBar locationId={defaultLocation} />
      <ShipmentOrdersTable
        locationId={defaultLocation}
        returning={returnType}
      />
    </HubCardStack>
  );
};

export default ShipmentOrdersContent;
